// extracted by mini-css-extract-plugin
module.exports = {"root":"DateRange_root__2-pD0","picker":"DateRange_picker__2le5O"};